import { scrollbarWidth } from "@xobotyi/scrollbar-width";

const CLASS_LOCKED = "locked";

function lock() {
    const body = document.body;
    body.classList.add(CLASS_LOCKED);
    body.style.marginRight = scrollbarWidth() + "px";
}

function unlock() {
    const body = document.body;
    body.classList.remove(CLASS_LOCKED);
    body.style.marginRight = 0;
}

const bodyLocker = {
    lock,
    unlock,
};

$(function () {
    $(
        `<style>:root {--scrollbarWidth: ${scrollbarWidth()}px}</style>`
    ).appendTo("head");
});

export default bodyLocker;
